import { Attachment } from 'src/app/front-user/shared/models/attachment.model';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { EbookingRequestTugDTO } from '../shared/models/ebooking-request-tug.model';
import { Status } from 'src/app/shared/models/general.model';

export class FeesEstimate {
    Id: string;
    RequestorId: string;
    RequestNumber: string;
    AgentName: string;
    VesselName: string;
    SCID: string;
    IMONO: string;
    CallSign: string;
    ShipTypeId: number;
    FuelTypeIds: string;
    FuelTypeOther: string;
    IMOCII: number;
    PropellerTypeId: number;
    IsScrubberInstalled: boolean;
    VesselTypeOther: string;
    ShipStatus: number;
    PassengersNumber: number;
    ShipmentTypeId: number;
    ShipmentQuantity: number
    IsMilitaryShip: boolean;
    MilitaryShipmentTypeId: number;
    MilitaryShipmentQuantity: number;
    IsRoofFloatingUnits: boolean;
    TotalSuezAmount: number;
    FloatingUnitHeight: number;
    FloatingUnitWidth: number;
    FloatingUnitLength: number;
    IsEmptyConatiners: boolean;
    FloorsNumber: number;
    IsRoofContainers: boolean;
    RoofContainerFloorsNumber: string;
    IsGasShip: boolean;
    GasType: string;
    GazAmount: string;
    ShipNationalityId: number;
    Height: number;
    Width: number;
    TotalSuezCanalAmout: number;
    SuezCanalNetTonnage: number;
    ArrivalDate: Date;
    AccessCapacity: number;
    TransitDate: Date;
    LastTransitDate: Date;
    GraveMaterial: string;
    SubmersibleAccess: string;
    Flake: string;
    Scouts: string;
    /* Deleted in Ebooking-Revamp */
    ComingFrom: string;
    DestinedTo: string;
    /* -------------------------- */
    MarineRequirements: string
    ValidFor: number;
    ReceiverUserName: string;
    SelectedCurrencyId: number;
    Currency: GenericLookup = new GenericLookup();
    Attachments: Attachment[] = [];
    InsuranceValue: number;
    FeeValue: number;
    TotalFees: number;
    StatusId: number;
    Status: Status;
    ExpirationDate: Date;
    ShipmentOther: string;
    MilitaryShipmentOther: string;
    MeasurementDescription: string;
    DirectionId: number;
    ContainerReduction: string;
    PrincipalName: string;
    PrincipalEMail: string;
    PrincipalFax: string;
    // Added in Ebooking-Revamp
    LastCountry: number;
    LastPort: number;
    OtherLastPort?: string;
    NextCountry: number;
    NextPort: number;
    OtherNextPort?: string;
    ShipSituation?: number;
    AdminSCGT?: number;
    AdminSCNT?: number;
    AgentEscortTugs?: number;
    Note?: string;
    DraftUnit: number;
    EbookingRequestTugs: EbookingRequestTugDTO[];
}